var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimelineDownloaded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.66699 11.332V12.6654C2.66699 13.019 2.80747 13.3581 3.05752 13.6082C3.30756 13.8582 3.6467 13.9987 4.00033 13.9987H12.0003C12.3539 13.9987 12.6931 13.8582 12.9431 13.6082C13.1932 13.3581 13.3337 13.019 13.3337 12.6654V11.332",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#7F56D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.66699 7.33203L8.00033 10.6654L11.3337 7.33203",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#7F56D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8 2.66797V10.668",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#7F56D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineDownloaded);
export default __webpack_public_path__ + "static/media/timeline-downloaded.78f95d82d2ecc6d38a27d7df0a23c123.svg";
export { ForwardRef as ReactComponent };